/* eslint-disable no-underscore-dangle */
/**
 * Helper: Klaviyo
 * -----------------------------------------------------------------------------
 * Performs Klaviyo tracking API calls
 *
 */

import formatMoney from '~/core/helpers/format-money'

/**
 * Sends data to Klaviyo
 * @param {String} {label} - The label to send
 * @param {Object} {value} - The value to send
 */
export function klaviyoEvent({ label, value }) {
  if (!window._learnq) {
    return
  }

  try {
    window._learnq.push(
      ['track', label],
      { value },
    )
  } catch (event) {
    console.error('[Klaviyo] Error sending _learnq event', event)
  }
}

/**
 * Sends add to cart item data to Klaviyo
 * @param {String} {label} - The item added to cart
 */
export function klaviyoAtcEvent(item) {
  if (!window._learnq || !item) {
    return
  }

  try {
    window._learnq.push(
      [
        'track',
        'Added to Cart',
        {
          Name: item.title,
          ProductID: item.id,
          ImageURL: item.featured_image?.url,
          URL: item.url,
          Brand: item.vendor,
          Price: parseFloat(formatMoney(item.price, '{{ money_without_currency }}', true)),
          CompareAtPrice: parseFloat(formatMoney(item.original_price, '{{ money_without_currency }}', true)),
        },
      ],
    )
  } catch (event) {
    console.error('[Klaviyo] Error sending _learnq event', event)
  }
}
